import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "notice-text"
}, "Congratulations", -1);
const _hoisted_2 = {
  class: "notice-text yellow"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "notice-text"
}, "Withdraw successfully", -1);
const _hoisted_4 = {
  class: "notice-text pink"
};
import { ref, onMounted, onUnmounted } from 'vue';
import ws from '@/connect';
const SCROLL_AMOUNT = 20;
export default {
  __name: 'WithdrawEvent',
  setup(__props) {
    const outBoxRef = ref();
    const boxRef = ref();
    const noticeList = ref([]);
    const currentNotice = ref(null);
    const textScrollInterval = ref(null);
    const showNotice = ref(true);
    const moving = ref(false);
    onMounted(() => {
      ws.registerCallBack('withdraw.notice.list', data => {
        noticeList.value = noticeList.value.concat(data || []);
        if (!moving.value) {
          doNotice();
        }
      });
    });
    onUnmounted(() => {
      if (ws.isConnect()) {
        ws.unregisterCallBack('withdraw.notice.list');
      }
    });
    const doNotice = () => {
      if (noticeList.value && noticeList.value.length > 0) {
        moving.value = true;
        currentNotice.value = noticeList.value.shift();
        showNotice.value = true;
        setTimeout(() => {
          startTextScroll();
        }, 1400);
      } else {
        moving.value = false;
      }
    };
    const startTextScroll = () => {
      let container = outBoxRef.value;
      let target = boxRef.value;
      let initLeft = 0;
      textScrollInterval.value = setInterval(function () {
        if (initLeft < target.offsetWidth - container.offsetWidth) {
          initLeft++;
          target.style = "transform: translateX(-" + initLeft + "px)";
        } else {
          clearInterval(textScrollInterval.value);
          showNotice.value = false;
          setTimeout(() => {
            target.style = "transform: translateX(-" + 0 + "px)";
            doNotice();
          }, 1600);
        }
      }, SCROLL_AMOUNT);
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      return currentNotice.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["withdraw-event-wrap", {
          'hide': !showNotice.value
        }])
      }, [_createVNode(_component_van_image, {
        class: "left-icon",
        src: require('@/assets/img/home/notice-withdraw.png')
      }, null, 8, ["src"]), _createElementVNode("div", {
        class: "notice-text-outbox",
        ref_key: "outBoxRef",
        ref: outBoxRef
      }, [_createElementVNode("div", {
        class: "notice-text-inbox flex",
        ref_key: "boxRef",
        ref: boxRef
      }, [_hoisted_1, _createElementVNode("div", _hoisted_2, _toDisplayString(currentNotice.value.username), 1), _hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(currentNotice.value.amount) + "p", 1)], 512)], 512)], 2)) : _createCommentVNode("", true);
    };
  }
};